module.exports = {"632522100":"尕巴松多镇","632522101":"唐谷镇","632522200":"巴沟乡","632522201":"秀麻乡","632522202":"河北乡","632522400":"省牧草良种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632522.json
// module id = 2788
// module chunks = 0